import React from 'react';
import clsx from 'clsx';

import CmtFooter from '../../../../../@coremat/CmtLayouts/Vertical/Footer';
import CmtVerticalLayout from '../../../../../@coremat/CmtLayouts/Vertical';
import CmtHeader from '../../../../../@coremat/CmtLayouts/Vertical/CmtHeader';
import CmtSidebar from '../../../../../@coremat/CmtLayouts/Vertical/Sidebar';
import CmtContent from '../../../../../@coremat/CmtLayouts/Vertical/Content';

import Header from '../../partials/Header/Header';
import SidebarHeader from '../../partials/SidebarHeader';
import SideBar from '../../partials/SideBar/SideBar';
import ContentLoader from '../../../ContentLoader';
import { SIDEBAR_TYPE } from '../../../../constants/ThemeOptions';
import Footer from '../../partials/Footer';
import defaultContext from '../../../contextProvider/AppContextProvider/defaultContext';
import useWidth from 'services/Hooks/useWidth';
import { useLocation } from 'react-router';
import CertificationToolHeader from '../../partials/Header/CertificationToolHeader';
import BrpClubHeader from '../../partials/Header/BrpClubHeader';
import { IsClub } from 'config/config';

const layoutOptions = {
  headerType: defaultContext.headerType,
  footerType: 'fixed',
  sidebarType: SIDEBAR_TYPE.MINI,
  isSidebarFixed: defaultContext.isSidebarFixed,
  isSidebarOpen: false,
  miniSidebarWidth: 80,
  layoutStyle: defaultContext.layoutType,
};

const VerticalMinimal = ({ className, children }) => {
  const width = useWidth();
  const location = useLocation();

  return (
    <CmtVerticalLayout
      layoutOptions={layoutOptions}
      className={clsx('verticalMinimalLayout', className)}
      header={
        <CmtHeader>
          {location.pathname.startsWith('/dealer/certification') ? (
            <CertificationToolHeader />
          ) : IsClub ? (
            <BrpClubHeader />
          ) : (
            <Header />
          )}
        </CmtHeader>
      }
      sidebar={
        width === 'sm' || width === 'xs'
          ? isSidebarOpen => (
              <CmtSidebar>
                <SidebarHeader isSidebarOpen={isSidebarOpen} />
                <SideBar />
              </CmtSidebar>
            )
          : ''
      }
      footer={
        <CmtFooter type="static">
          <Footer />
        </CmtFooter>
      }>
      <CmtContent>
        {children}
        <ContentLoader />
      </CmtContent>
    </CmtVerticalLayout>
  );
};

export default VerticalMinimal;
